import {
    DependenciesPayload,
    NextBillItem,
} from '@sxm-de/dev-kits/web-sdk/types';
import { MapClientSdkToWebSdk } from '@sxm-de/dev-kits/web-sdk/utils';

export async function getBillingProfileNextBill(
    { billingProfileId }: { billingProfileId: string },
    { clientSdk }: DependenciesPayload,
): Promise<{
    items: NextBillItem[];
}> {
    const mapClientSdkToWebSdk: MapClientSdkToWebSdk<
        Awaited<
            ReturnType<
                typeof clientSdk.commerce.billing.getBillingProfileNextBill
            >
        >,
        {
            items: NextBillItem[];
        }
    > = ({ items }) => {
        return {
            items: items.map((item) => {
                return {
                    ...item,
                    offerId: item.offerId || '',
                };
            }),
        };
    };
    const { items } = mapClientSdkToWebSdk(
        await clientSdk.commerce.billing.getBillingProfileNextBill(
            billingProfileId,
        ),
    );
    return { items };
}
